import { IOrderEntity } from '../Services/api/orders/orders.interface'
import { normalizeOrderApiResponse } from './normalize-order-api-response'

/** @deprecated Use normalizeOrderApiResponse */
export function normalizeOrderEntity(raw: IOrderEntity): IOrderEntity {
  return normalizeOrderApiResponse(raw)
}
